import { ListItemIcon } from "@mui/material";
import { ListBulletIcon, PlusCircleIcon } from "@heroicons/react/24/solid";
import React from "react";
import { useNavigate } from "react-router-dom";
import * as enums from "src/lib/enums";
import { Article } from "src/api/articles/articleTypes";

function ArticleMenu({
	handleSelectArticle
}: {
	handleSelectArticle: (article?: Article) => void;
}) {
	const navigate = useNavigate();
	return (
		<div className="flex flex-row gap-3 items-center p-2 bg-blue-200/20 shadow-[0_5px_10px_-5px_rgba(0,0,0,0.3)]">
			<div
				className="flex flex-row gap-2 items-center p-2 cursor-pointer"
				onClick={() => {
					navigate(enums.PAGES_ARTICLE_LIST);
				}}
			>
				<ListBulletIcon className="w-8 h-8" /> Liste des articles
			</div>
			<div
				className="flex flex-row gap-2 items-center p-2 cursor-pointer"
				onClick={() => {
					handleSelectArticle(undefined);
				}}
			>
				<PlusCircleIcon className="w-8 h-8" />
				Ajouter un article
			</div>
		</div>
	);
}

export default ArticleMenu;
